import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import "@/company.css";
import "@/studio.css";

const links = [
  { label: "Home", to: "/" },
  { label: "Games", to: "/games" },
  { label: "Apps", to: "/apps" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export function Brand({ light = false }) {
  return (
    <Link className={light ? "db-brand db-brand-light" : "db-brand"} to="/" aria-label="Dream Big Entertainment home">
      <img className="db-brand-logo" src="/colour-cubes/dream-big-ent.webp" alt="Dream Big Ent" width="600" height="240" />
    </Link>
  );
}

function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="db-header">
      <div className="db-container db-header-inner">
        <Brand />
        <nav className="db-nav" aria-label="Main navigation">
          {links.map((item) => (
            <Link key={item.to} to={item.to} className={pathname === item.to ? "db-nav-link is-active" : "db-nav-link"}>
              {item.label}
            </Link>
          ))}
        </nav>
        <Link className="db-header-cta" to="/#products">Explore products <ArrowUpRight size={16} /></Link>
        <button className="db-menu-toggle" type="button" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="db-mobile-nav" aria-label="Mobile navigation">
          {links.map((item) => <Link key={item.to} to={item.to} onClick={() => setOpen(false)}>{item.label}<ArrowUpRight size={18} /></Link>)}
        </nav>
      )}
    </header>
  );
}

function Footer() {
  return (
    <footer className="db-footer">
      <div className="db-container">
        <div className="db-footer-main">
          <div>
            <Brand light />
            <p>Games, apps and digital experiences that entertain, inspire and make life easier.</p>
          </div>
          <div className="db-footer-links">
            <div><span>EXPLORE</span><Link to="/games">Games</Link><Link to="/apps">Apps</Link><Link to="/colour-cubes">Colour Cubes</Link><Link to="/">Home</Link><Link to="/forgot-ai">Forgot AI</Link><Link to="/about">About</Link><Link to="/contact">Contact</Link></div>
            <div><span>PRIVACY & LEGAL</span><Link to="/colour-cubes/privacy-policy">Colour Cubes privacy</Link><Link to="/colour-cubes/support">Colour Cubes support</Link><span>FORGOT AI</span><Link to="/forgot-ai/support">Support</Link><Link to="/forgot-ai/privacy">Privacy policy</Link><Link to="/forgot-ai/terms">Terms of use</Link><span className="db-footer-previous">PREVIOUS PROJECT</span><Link to="/found/legal">FOUND legal & support</Link></div>
          </div>
        </div>
        <div className="db-footer-bottom"><span>© 2026 Dream Big Entertainment Ltd.</span><span>Built to make the everyday feel easier.</span></div>
      </div>
    </footer>
  );
}

export function PhoneMockup({ src, alt, className = "", eager = false }) {
  return <div className={"db-phone " + className}><img src={src} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" /></div>;
}

export default function CompanyLayout({ children }) {
  const { pathname } = useLocation();
  const studio = pathname === "/" || pathname === "/games" || pathname === "/apps" || pathname.startsWith("/colour-cubes");
  return <div className={"db-site"+(studio?" db-studio":"")}><a className="studio-skip" href="#main-content">Skip to content</a><Header /><div id="main-content" tabIndex="-1">{children}</div><Footer /></div>;
}
